var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBananasBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.073,
    height: 16.698,
    viewBox: "0 0 19.073 16.698",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3370",
    "data-name": "Group 3370",
    transform: "translate(0.349 0.35)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3515",
    "data-name": "Path 3515",
    d: "M1534.381,318.431a9.407,9.407,0,0,1-3.425-.592,6.8,6.8,0,0,1-3.057-2.334,1.243,1.243,0,0,1,.683-1.937l.038-.01a3.212,3.212,0,0,1,.906-.082c.147.007.307.01.473.01a15.551,15.551,0,0,0,5.637-1.091,13.466,13.466,0,0,0,6.792-5.928c.274-.476.591-.983.969-1.552a2.959,2.959,0,0,0,.347-2.272.766.766,0,0,1,.147-.617.756.756,0,0,1,.555-.289,2.477,2.477,0,0,1,.853.094.75.75,0,0,1,.512.923,3.872,3.872,0,0,0,.14,2.288,8.557,8.557,0,0,1,.373,4.279c-.483,2.663-2.141,6.267-7.3,8.318l-.007,0A14.7,14.7,0,0,1,1534.381,318.431Zm-5.018-4.259a2.417,2.417,0,0,0-.574.065l-.03.008a.528.528,0,0,0-.369.341.536.536,0,0,0,.073.5,6.9,6.9,0,0,0,5.918,2.641,14.262,14.262,0,0,0,4.394-.745c4.853-1.932,6.41-5.3,6.861-7.791a7.857,7.857,0,0,0-.347-3.927,4.574,4.574,0,0,1-.152-2.7.055.055,0,0,0-.042-.065,1.783,1.783,0,0,0-.612-.064.053.053,0,0,0-.041.021.064.064,0,0,0-.011.053,3.641,3.641,0,0,1-.452,2.792c-.369.556-.678,1.051-.945,1.514a14.15,14.15,0,0,1-7.138,6.228,16.27,16.27,0,0,1-5.9,1.141c-.177,0-.347,0-.5-.011Z",
    transform: "translate(-1527.725 -302.082)",
    fill: "#22294D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3516",
    "data-name": "Path 3516",
    d: "M1530.461,329.023a.349.349,0,0,1-.147-.032,6.668,6.668,0,0,1-3.64-3.792,1.185,1.185,0,0,1,1.138-1.594h.04a3.37,3.37,0,0,1,.827.158,18,18,0,0,0,5.193.847h.046a11.435,11.435,0,0,0,7.274-2.472.35.35,0,0,1,.436.547,12.119,12.119,0,0,1-7.708,2.625h-.05a18.56,18.56,0,0,1-5.391-.876,2.735,2.735,0,0,0-.656-.13h-.041a.472.472,0,0,0-.389.2.478.478,0,0,0-.062.451,5.992,5.992,0,0,0,3.277,3.4.35.35,0,0,1-.147.668Z",
    transform: "translate(-1526.951 -316.973)",
    fill: "#22294D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3517",
    "data-name": "Path 3517",
    d: "M1536.556,317.72a.348.348,0,0,1-.183-.052,6.383,6.383,0,0,1-3.058-4.2,1.1,1.1,0,0,1,1.286-1.291l.03.006a2.525,2.525,0,0,1,.746.277,12.409,12.409,0,0,0,4.585,1.574,10.917,10.917,0,0,0,7.827-2.051.35.35,0,0,1,.4.574,11.6,11.6,0,0,1-8.317,2.171,13.1,13.1,0,0,1-4.844-1.66,1.821,1.821,0,0,0-.537-.2l-.024,0a.391.391,0,0,0-.355.11.4.4,0,0,0-.112.361,5.7,5.7,0,0,0,2.738,3.732.35.35,0,0,1-.184.648Z",
    transform: "translate(-1531.853 -309.547)",
    fill: "#22294D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBananasBlue);
export default __webpack_public_path__ + "static/media/bananas_blue.4b0b17f462ae216a0d752ef573470cd9.svg";
export { ForwardRef as ReactComponent };